import { useQuery } from "@tanstack/react-query";

import { getFilesUrls } from "../_services/fileService.ts";

type DataFiles = { urls: string[] };

export const useGetFile = ({
  enabled,
  listFiles,
  keys,
}: {
  enabled: boolean;
  listFiles: string[];
  keys: string[];
}) => {
  const queryFiles = useQuery<DataFiles, Error>(
    ["files", ...keys],
    () => getFilesUrls(listFiles),
    {
      enabled,
    },
  );

  const getFile = async (
    callback?: (data: string) => void,
  ): Promise<string | null> => {
    const { data } = await queryFiles.refetch();
    if (callback && data) {
      callback(data.urls[0]);
    }
    return null;
  };

  return { data: queryFiles.data, isLoading: queryFiles.isLoading, getFile };
};
